module.exports = __webpack_public_path__ + "static/media/dashboard.897239e7.png";